<template v-if="skin">
  <v-card flat class="catalog-list mb-2" width="auto">
    <v-card-title>
      <h4>{{ title }}</h4>
    </v-card-title>
    <v-divider></v-divider>
    <ul>
      <li v-for="(group, index) in groups" :key="`${group.name}-${group.id}-${index}`" @mouseenter="handlePreview(group)" :class="[{ 'active': inGroupBasket(group) }]" >
        <v-layout align-center>
          <span class="mr-2" v-html="renderIcon(group)"
            @click="toggleSelected(group)"></span>
          <v-flex class="px-2 py-2" @click="toggleSelected(group)" align-center
            style="white-space: normal !important; word-wrap: break-word">
            {{ group.name.replace(/[, ]+/g, " ") }}
          </v-flex>
          <v-flex shrink class="pb-2 pt-2">
            <button @click="go(group)" class="action white--text text-xs-center pa-1 primary">
              <small>{{ $t("Catalog.go") }}</small>
            </button>
          </v-flex>
        </v-layout>
      </li>
    </ul>
  </v-card>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  name: "ListCatalogGroups",
  props: {
    groups: {
      type: Array,
      required: true
    },
    title: {
      type: String
    },
    helperObject: {
      type: Object,
      required: false
    },
    listTarget: {
      type: Array
    },
    listType: {
      type: String
    },
    // Vuex state name
    model: {
      type: String,
      required: true
    },
  },
  computed: {
    ...mapGetters({
      basicCatalogRequest: 'parts/basicCatalogRequest',
      totalPartBasketCount: 'parts/totalPartBasketCount'
    }),
    ...mapState({
      skin: state => state.settings.skin
    })
  },
  methods: {
    ...mapActions({
      TOGGLE_SELECTION_GROUP: "parts/TOGGLE_SELECTION_GROUP",
      INQUIRY: "parts/INQUIRY"
    }),
    renderIcon(group) {
      return this.inGroupBasket(group)
        ? ('<i aria-hidden="true" class="v-icon material-icons primary--text">check_box</i>')
        : ('<i aria-hidden="true" class="v-icon dark material-icons theme--light">check_box_outline_blank</i>')
    },
    inGroupBasket(group) {
      return (this.$store.state.parts[this.model].findIndex(i => i.id == group.id)) !== -1
    },
    select(group) {
      this.$emit("SelectFn", { category: this.helperObject, group });
    },
    preview(params) {
      this.$emit("PreviewFn", params);
    },
    handlePreview(group) {
      if (this.listType == "group") this.preview(group);
    },
    toggleSelected(group) {
      this.$emit("Update", { model: this.model, group });
    },
    go(group) {
      this.$emit("click", { model: this.model, group })
    },
  }
};
</script>